import { render } from "./HelpTournamentDialog.vue?vue&type=template&id=ca09f7e4"
import script from "./HelpTournamentDialog.vue?vue&type=script&lang=js"
export * from "./HelpTournamentDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__